import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useAppSelector } from "../../redux/store"
import Preloader from "./Preloader/Preloader"
import Loader from "@/Loader"

const PublicRoute = () => {
  const { isAuth, isLoading } = useAppSelector((state) => state.auth)
  const location = useLocation()
  if (isLoading) {
    return <Loader />
  } else {
    return isAuth === false ? (
      <>
        {" "}
        <Outlet />
        {/* <Navigate to="/guest/create-event" state={{ from: location }} replace /> */}
      </>
    ) : (
      <Navigate to="/" state={{ from: location }} replace />
    )
  }
}

export default PublicRoute
